<mat-spinner *ngIf="isLoading()"></mat-spinner>
<mat-slide-toggle *ngIf="!isLoading()" [checked]="isElementActive()" (change)="toogleActive(element)">{{getLabel()}}</mat-slide-toggle>